import manualOrderSaga from '~/sagas/manual-order/manual-order.saga';

export default manualOrderSaga;
